// ─────────────────────────────────────────────────────────────────────────
// `/shop` — everything that is for sale, on one page.
//
// It sits on the marketing host with the rest of the pages a stranger reads,
// and `MarketingV2App` dispatches it exactly the way it dispatches `/score`.
// Unlike `/p/<slug>` and `/checkout/<sku>`, the shop KEEPS the site chrome:
// somebody browsing what is on offer should be able to get back to the rest of
// the site, which is the opposite of what a landing page wants.
//
//   /shop        the page
//   /shop/       the same page
//   ?view=shop   local dev, from the default surface
//
// No router dependency, matching every other surface in this repo.
// ─────────────────────────────────────────────────────────────────────────

export const SHOP_PATH = '/shop';

/** Cheap and total: called before the marketing surface renders anything. */
export function isShopPath(pathname: string, search = ''): boolean {
  const path = pathname.replace(/\/+$/, '') || '/';
  if (path === SHOP_PATH) return true;
  return new URLSearchParams(search).get('view') === 'shop';
}

/** Absolute URL for the shop — for anywhere a full address is wanted. */
export function shopUrl(origin: string): string {
  return `${origin.replace(/\/$/, '')}${SHOP_PATH}`;
}
